document.addEventListener('DOMContentLoaded', () => {
  const checkbox = document.getElementById('giftBoxToggle');
  if (!checkbox) return;

  const VARIANT_ID = Number(checkbox.dataset.variantId);

  async function getCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  async function addGiftBox() {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: VARIANT_ID,
            quantity: 1,
            properties: {
              _gift_box: 'true'
            }
          }
        ]
      })
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.description || data.message || 'Dodavanje kutije nije uspelo.');
    }

    return data;
  }

  async function removeGiftBox(lineItemKey) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: lineItemKey,
        quantity: 0
      })
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.description || data.message || 'Uklanjanje kutije nije uspelo.');
    }

    return data;
  }

  async function syncCheckboxWithCart() {
    const cart = await getCart();
    const giftBoxItem = cart.items.find(item => item.variant_id === VARIANT_ID);
    checkbox.checked = !!giftBoxItem;
  }

  checkbox.addEventListener('change', async function () {
    try {
      checkbox.disabled = true;

      const cart = await getCart();
      const giftBoxItem = cart.items.find(item => item.variant_id === VARIANT_ID);

      if (checkbox.checked) {
        if (!giftBoxItem) {
          await addGiftBox();
        }
      } else {
        if (giftBoxItem) {
          await removeGiftBox(giftBoxItem.key);
        }
      }

      window.location.reload();
    } catch (error) {
      console.error('GIFT BOX ERROR:', error);
      alert(error.message);
      checkbox.checked = !checkbox.checked;
    } finally {
      checkbox.disabled = false;
    }
  });

  syncCheckboxWithCart();
});